const styles = {
  0: {
    backgroundColor: 'rgba(187, 53, 170, 0.1)',
    border: '1px solid rgba(187, 53, 170, 0.2)',
    color: '#BB35AA',
  },
  1: {
    backgroundColor: 'rgba(126, 97, 255, 0.1)',
    border: '1px solid rgba(126, 97, 255, 0.2)',
    color: '#7E61FF',
  },
  2: {
    backgroundColor: 'rgba(250, 191, 94, 0.1)',
    border: '1px solid rgba(250, 191, 94, 0.2)',
    color: '#FABF5E',
  },
  3: {
    backgroundColor: 'rgba(255, 145, 134, 0.1)',
    border: '1px solid rgba(255, 145, 134, 0.2)',
    color: '#FF9186',
  },
  4: {
    backgroundColor: 'rgba(0, 152, 205, 0.1)',
    border: '1px solid rgba(0, 152, 205, 0.2)',
    color: '#0098CD',
  },
  5: {
    backgroundColor: 'rgba(42, 94, 246, 0.1)',
    border: '1px solid rgba(42, 94, 246, 0.2)',
    color: '#2A5EF6',
  },
  6: {
    backgroundColor: 'rgba(255, 111, 97, 0.1)',
    border: '1px solid rgba(255, 111, 97, 0.2)',
    color: '#FF6F61',
  },
  7: {
    backgroundColor: 'rgba(30, 190, 130, 0.1)',
    border: '1px solid rgba(30, 190, 130, 0.2)',
    color: '#1EBE82',
  },
}
const sizes = {
  small: { dimensions: '24px', fontSize: '14px' },
  medium: { dimensions: '36px', fontSize: '16px' },
  large: { dimensions: '40px', fontSize: '18px' },
}

interface AvatarProps {
  name: string
  size?: 'small' | 'medium' | 'large'
  margin?: string
}

function generateNumberFromString(str: string) {
  // Initialize a variable to store the sum of character codes
  let sum = 0

  // Loop through each character of the string
  for (let i = 0; i < str.length; i++) {
    // Get the character code at the current index
    const charCode = str.charCodeAt(i)

    // Add the character code to the sum
    sum += charCode
  }

  // Take the modulus of the sum with 8 to get a number between 0 and 7
  const number = sum % 8

  return number
}

const Avatar = ({ name, size = 'medium', margin = '0' }: AvatarProps) => {
  const initials = name?.substring(0, size === 'small' ? 1 : 2)
  const { fontSize, dimensions } = sizes[size]
  const stylesIndex = generateNumberFromString(name)

  return (
    <div
      style={{
        ...styles[stylesIndex],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '100%',
        height: dimensions,
        width: dimensions,
        lineHeight: 1,
        fontSize,
        margin,
        textTransform: 'uppercase',
      }}>
      {initials}
    </div>
  )
}

export default Avatar
